/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleListItemViewModel } from "../types/ClassModuleListItemViewModel.ts";
import { eCourseModalitySchema } from "./eCourseModalitySchema.ts";

export const classModuleListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  dateStart: z.string().datetime().nullish(),
  dateFinish: z.string().datetime().nullish(),
  companyId: z.number().int().nullish(),
  modality: z.optional(
    z
      .lazy(() => eCourseModalitySchema)
      .describe(
        "1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand | ",
      ),
  ),
}) as unknown as ToZod<ClassModuleListItemViewModel>;
